var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint, useToasts } from "@brg/ui";
import ImageArrayComponent from "./ImageArrayComponent";
import { useProfile } from "@brg/auth";
import { CommentEditContainer, CommentEditTitle, CommentInputContainer } from "../../styles";
import { CHAT_CLOSED_STATUS, COMMENT_EDIT_MODE, COMMENT_NOTIF_TYPE, INITIAL_REQUEST_FILTER } from "../../const/const";
import { LayoutConst } from "../../../../../constants/media";
import { useGetCommentsHandlers } from "../../handlers/CommentHandlers";
import { getChat } from "../../../../../reducers/chatReducer";
import { updateCommentStart, onUpdateChatState } from "../../../../../actions/chatActions";
import useLocalization from "../../../../../hooks/useLocalization";
import { Input } from "@brg/input";
import styled, { css } from "styled-components";
import { ImageIcon } from "../../assets/ImageIcon";
import { RectangularButtonFilled } from "../../../../../stylesItems/styles";
var TIMEOUT = 5000;
export var CommentEdit = function (_a) {
    var entityId = _a.entityId, postEntityId = _a.postEntityId, mode = _a.mode, _b = _a.comment, comment = _b === void 0 ? undefined : _b, onUpdate = _a.onUpdate;
    var _c = useLocalization(), t = _c.t, language = _c.language;
    var toasts = useToasts();
    var dispatch = useDispatch();
    var profile = useProfile();
    var postIdRef = useRef(null);
    var isMobile = useBreakpoint(LayoutConst.container.s - 1);
    var textareaRef = useRef(null);
    var _d = useSelector(function (store) { return getChat(store); }), answerId = _d.answerId, permissions = _d.permissions;
    var _e = useState(Date.now()), time = _e[0], setTime = _e[1];
    var _f = useState(false), isCreated = _f[0], setIsCreated = _f[1];
    var _g = useState(false), imageMode = _g[0], setImageMode = _g[1];
    var _h = useState({
        text: '',
        attachments: []
    }), data = _h[0], setData = _h[1];
    var closedStatus = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.closedStatus) || false; }, [permissions]);
    var isBlackList = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.isBlackList) || false; }, [permissions]);
    var isWhiteList = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.isWhiteList) || false; }, [permissions]);
    var isPrivateChat = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.isPrivateChat) || false; }, [permissions]);
    var entityType = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.entityType) || undefined; }, [permissions]);
    var _j = useGetCommentsHandlers(), onAdd = _j.onAdd, onEdit = _j.onEdit;
    var resetState = function (id, updateMessages) {
        setTimeout(function () {
            var _a;
            if (updateMessages) {
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate();
            }
            dispatch(onUpdateChatState({
                scrollId: ((_a = [
                    COMMENT_EDIT_MODE.add,
                    COMMENT_EDIT_MODE.edit
                ]) === null || _a === void 0 ? void 0 : _a.includes(mode)) ? id : null,
                filter: INITIAL_REQUEST_FILTER,
                answerId: null
            }));
            setData({
                text: '',
                attachments: []
            });
            setImageMode(false);
            setTime(Date.now());
        });
    };
    var handleTextChange = function (ev) {
        var newComment = __assign({}, data);
        newComment.text = ev.target.value;
        setData(__assign(__assign({}, data), { text: ev.target.value }));
    };
    var handleAttachmentsChange = function (newData) {
        var newComment = __assign({}, data);
        var attachments = newData;
        setData(__assign(__assign({}, newComment), { attachments: attachments }));
    };
    var handleToggleMode = function () {
        setImageMode(!imageMode);
    };
    var hasParentId = useMemo(function () {
        var _a;
        return (_a = [COMMENT_EDIT_MODE.edit, COMMENT_EDIT_MODE.answer]) === null || _a === void 0 ? void 0 : _a.includes(mode);
    }, [mode]);
    var handleAddNewMessage = function () {
        var _a;
        if (isPrivateChat && !isWhiteList) {
            toasts.error(t('chat.errors.whitelist'));
            return;
        }
        if (isBlackList) {
            toasts.error(t('chat.errors.blacklist'));
            return;
        }
        onAdd === null || onAdd === void 0 ? void 0 : onAdd(__assign(__assign(__assign({}, data), { accountId: (_a = profile === null || profile === void 0 ? void 0 : profile.accountId) !== null && _a !== void 0 ? _a : '', entityId: entityId, entityType: entityType, type: COMMENT_NOTIF_TYPE.add }), (hasParentId ? { parentId: answerId } : {}))).then(function (response) { return response.json(); }).then(function (comment) {
            if (!!comment.id) {
                dispatch(updateCommentStart({
                    entityId: entityId,
                    postEntityId: postEntityId,
                    comment: __assign({}, comment),
                    mode: mode
                }));
                resetState(comment.id, true);
                // setTimeout(() => {
                //     dispatch(updateCommentEnd({ 
                //         comment: {...comment, loading: false }, 
                //         postEntityId, isCreated: true 
                //     }))
                // } , TIMEOUT)
            }
        });
    };
    var handleEditMessage = function () {
        if (isPrivateChat && !isWhiteList) {
            toasts.error(t('chat.errors.whitelist'));
            return;
        }
        if (isBlackList) {
            toasts.error(t('chat.errors.blacklist'));
            return;
        }
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(__assign(__assign({}, comment), { 
            //@ts-ignore
            account: null, text: data.text, attachments: data.attachments || [], comments: null })).then(function (response) { return response.json(); }).then(function (item) {
            if (!!item.id) {
                dispatch(updateCommentStart({
                    mode: mode,
                    entityId: item === null || item === void 0 ? void 0 : item.entityId,
                    postEntityId: postEntityId,
                    comment: __assign(__assign({}, item), { loading: true }),
                }));
                resetState(item.id, true);
                // setTimeout(() => {
                //     dispatch(updateCommentEnd({ comment: {...item, loading: false}, postEntityId, isCreated: false }))
                // } , TIMEOUT)
            }
        });
    };
    var onSubmit = function () {
        mode === COMMENT_EDIT_MODE.edit ? handleEditMessage() : handleAddNewMessage();
    };
    useEffect(function () {
        var _a;
        if (!!comment) {
            setData({
                text: comment.text,
                attachments: comment.attachments || []
            });
        }
        if (!!((_a = comment === null || comment === void 0 ? void 0 : comment.attachments) === null || _a === void 0 ? void 0 : _a.length)) {
            setImageMode(true);
        }
    }, [comment]);
    useEffect(function () {
        if (isCreated) {
            setData({
                text: '',
                attachments: []
            });
            setImageMode(false);
        }
    }, [isCreated]);
    var disableSubmit = useMemo(function () {
        var _a, _b;
        return !(((_a = data === null || data === void 0 ? void 0 : data.text) === null || _a === void 0 ? void 0 : _a.length) ||
            ((_b = data === null || data === void 0 ? void 0 : data.attachments) === null || _b === void 0 ? void 0 : _b.length)) || isBlackList ||
            isPrivateChat && !isWhiteList;
    }, [data, isBlackList]);
    var disableImageIcon = useMemo(function () {
        return isPrivateChat && !isWhiteList || isBlackList;
    }, [data, isBlackList, isPrivateChat]);
    var banEdit = useMemo(function () {
        return (isPrivateChat && !isWhiteList || isBlackList);
    }, [isBlackList, isPrivateChat, isWhiteList]);
    useEffect(function () {
        var _a;
        if (answerId && mode === COMMENT_EDIT_MODE.answer) {
            (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [answerId, textareaRef.current, mode]);
    var notAlloweMsg = useMemo(function () {
        if (isBlackList) {
            return t('chat.errors.blacklist');
        }
        else if (isPrivateChat && !isWhiteList) {
            return t('chat.errors.whitelist');
        }
        return '';
    }, [language]);
    var textarea = useMemo(function () { return (React.createElement(React.Fragment, null, banEdit ? notAlloweMsg : (React.createElement(React.Fragment, null,
        React.createElement(Input.Textarea, { maxLength: 800, value: data.text, className: "mobile-textarea", onChange: handleTextChange, autoFocus: true, placeholder: t('editor.placeholders.something') }))))); }, [data, t, language, banEdit, notAlloweMsg]);
    var title = useMemo(function () {
        if (mode === COMMENT_EDIT_MODE.add) {
            return t("chat.post.add_comment");
        }
        else if (mode === COMMENT_EDIT_MODE.edit) {
            return t("chat.post.update_comment");
        }
        else {
            return t("chat.post.answer");
        }
    }, [mode, language]);
    var imageComponent = useMemo(function () {
        return (React.createElement("div", { style: { display: imageMode ? 'block' : 'none' } },
            React.createElement(ImageArrayComponent, { isEditing: mode === COMMENT_EDIT_MODE.edit, attachments: data.attachments, onChange: handleAttachmentsChange, update: time })));
    }, [mode, data, language, handleAttachmentsChange, time]);
    // if (!profile || closedStatus === CHAT_CLOSED_STATUS.pause) {
    //     return null;
    // }
    return (React.createElement(CommentEditContainer, { disablePadding: mode === COMMENT_EDIT_MODE.answer, "data-message-id": "".concat(mode === COMMENT_EDIT_MODE.answer ? 'answer' : 'edit', "-container") },
        React.createElement(FlexBox, { width: '100%', direction: "column", directionMobile: "column", gy: 16, gyMobile: 16 },
            !isBlackList && (React.createElement(CommentEditTitle, null, title)),
            React.createElement(FlexBox, { width: '100%' },
                React.createElement(CommentInputContainer, { ref: textareaRef, className: "input-container", direction: "column", directionMobile: "column" }, textarea),
                disableImageIcon ? null : (React.createElement(FlexBox, { offsetLeft: 24, align: "flex-end" },
                    React.createElement(ImageIcon, { onClick: handleToggleMode })))),
            imageComponent),
        React.createElement(FlexBox, null,
            React.createElement(RectangularButtonFilled, { disabled: disableSubmit, onClick: onSubmit }, t("chat.post.send")))));
};
//# sourceMappingURL=CommentEdit.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint, useToasts } from "@brg/ui";
import ImageArrayComponent from "./ImageArrayComponent";
import { useProfile } from "@brg/auth";
import { CommentEditContainer, CommentEditTitle, CommentInputContainer } from "../../styles";
import { CHAT_CLOSED_STATUS, COMMENT_EDIT_MODE, COMMENT_NOTIF_TYPE, INITIAL_REQUEST_FILTER } from "../../const/const";
import { LayoutConst } from "../../../../../constants/media";
import { useGetCommentsHandlers } from "../../handlers/CommentHandlers";
import { getChat } from "../../../../../reducers/chatReducer";
import { updateCommentStart, onUpdateChatState } from "../../../../../actions/chatActions";
import useLocalization from "../../../../../hooks/useLocalization";
import { Input } from "@brg/input";
import styled, { css } from "styled-components";
import { ImageIcon } from "../../assets/ImageIcon";
import { RectangularButtonFilled } from "../../../../../stylesItems/styles";
var TIMEOUT = 5000;
export var CommentEdit = function (_a) {
    var entityId = _a.entityId, postEntityId = _a.postEntityId, mode = _a.mode, _b = _a.comment, comment = _b === void 0 ? undefined : _b, onUpdate = _a.onUpdate;
    var _c = useLocalization(), t = _c.t, language = _c.language;
    var toasts = useToasts();
    var dispatch = useDispatch();
    var profile = useProfile();
    var postIdRef = useRef(null);
    var isMobile = useBreakpoint(LayoutConst.container.s - 1);
    var textareaRef = useRef(null);
    var _d = useSelector(function (store) { return getChat(store); }), answerId = _d.answerId, permissions = _d.permissions;
    var _e = useState(Date.now()), time = _e[0], setTime = _e[1];
    var _f = useState(false), isCreated = _f[0], setIsCreated = _f[1];
    var _g = useState(false), imageMode = _g[0], setImageMode = _g[1];
    var _h = useState({
        text: '',
        attachments: []
    }), data = _h[0], setData = _h[1];
    var closedStatus = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.closedStatus) || false; }, [permissions]);
    var isBlackList = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.isBlackList) || false; }, [permissions]);
    var isWhiteList = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.isWhiteList) || false; }, [permissions]);
    var isPrivateChat = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.isPrivateChat) || false; }, [permissions]);
    var entityType = useMemo(function () { return (permissions === null || permissions === void 0 ? void 0 : permissions.entityType) || undefined; }, [permissions]);
    var _j = useGetCommentsHandlers(), onAdd = _j.onAdd, onEdit = _j.onEdit;
    var resetState = function (id, updateMessages) {
        setTimeout(function () {
            var _a;
            if (updateMessages) {
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate();
            }
            dispatch(onUpdateChatState({
                scrollId: ((_a = [
                    COMMENT_EDIT_MODE.add,
                    COMMENT_EDIT_MODE.edit
                ]) === null || _a === void 0 ? void 0 : _a.includes(mode)) ? id : null,
                filter: INITIAL_REQUEST_FILTER,
                answerId: null
            }));
            setData({
                text: '',
                attachments: []
            });
            setImageMode(false);
            setTime(Date.now());
        });
    };
    var handleTextChange = function (ev) {
        var newComment = __assign({}, data);
        newComment.text = ev.target.value;
        setData(__assign(__assign({}, data), { text: ev.target.value }));
    };
    var handleAttachmentsChange = function (newData) {
        var newComment = __assign({}, data);
        var attachments = newData;
        setData(__assign(__assign({}, newComment), { attachments: attachments }));
    };
    var handleToggleMode = function () {
        setImageMode(!imageMode);
    };
    var hasParentId = useMemo(function () {
        var _a;
        return (_a = [COMMENT_EDIT_MODE.edit, COMMENT_EDIT_MODE.answer]) === null || _a === void 0 ? void 0 : _a.includes(mode);
    }, [mode]);
    var handleAddNewMessage = function () {
        var _a;
        if (isPrivateChat && !isWhiteList) {
            toasts.error(t('chat.errors.whitelist'));
            return;
        }
        if (isBlackList) {
            toasts.error(t('chat.errors.blacklist'));
            return;
        }
        onAdd === null || onAdd === void 0 ? void 0 : onAdd(__assign(__assign(__assign({}, data), { accountId: (_a = profile === null || profile === void 0 ? void 0 : profile.accountId) !== null && _a !== void 0 ? _a : '', entityId: entityId, entityType: entityType, type: COMMENT_NOTIF_TYPE.add }), (hasParentId ? { parentId: answerId } : {}))).then(function (response) { return response.json(); }).then(function (comment) {
            if (!!comment.id) {
                dispatch(updateCommentStart({
                    entityId: entityId,
                    postEntityId: postEntityId,
                    comment: __assign({}, comment),
                    mode: mode
                }));
                resetState(comment.id, true);
                // setTimeout(() => {
                //     dispatch(updateCommentEnd({ 
                //         comment: {...comment, loading: false }, 
                //         postEntityId, isCreated: true 
                //     }))
                // } , TIMEOUT)
            }
        });
    };
    var handleEditMessage = function () {
        if (isPrivateChat && !isWhiteList) {
            toasts.error(t('chat.errors.whitelist'));
            return;
        }
        if (isBlackList) {
            toasts.error(t('chat.errors.blacklist'));
            return;
        }
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(__assign(__assign({}, comment), { 
            //@ts-ignore
            account: null, text: data.text, attachments: data.attachments || [], comments: null })).then(function (response) { return response.json(); }).then(function (item) {
            if (!!item.id) {
                dispatch(updateCommentStart({
                    mode: mode,
                    entityId: item === null || item === void 0 ? void 0 : item.entityId,
                    postEntityId: postEntityId,
                    comment: __assign(__assign({}, item), { loading: true }),
                }));
                resetState(item.id, true);
                // setTimeout(() => {
                //     dispatch(updateCommentEnd({ comment: {...item, loading: false}, postEntityId, isCreated: false }))
                // } , TIMEOUT)
            }
        });
    };
    var onSubmit = function () {
        mode === COMMENT_EDIT_MODE.edit ? handleEditMessage() : handleAddNewMessage();
    };
    useEffect(function () {
        var _a;
        if (!!comment) {
            setData({
                text: comment.text,
                attachments: comment.attachments || []
            });
        }
        if (!!((_a = comment === null || comment === void 0 ? void 0 : comment.attachments) === null || _a === void 0 ? void 0 : _a.length)) {
            setImageMode(true);
        }
    }, [comment]);
    useEffect(function () {
        if (isCreated) {
            setData({
                text: '',
                attachments: []
            });
            setImageMode(false);
        }
    }, [isCreated]);
    var disableSubmit = useMemo(function () {
        var _a, _b;
        return !(((_a = data === null || data === void 0 ? void 0 : data.text) === null || _a === void 0 ? void 0 : _a.length) ||
            ((_b = data === null || data === void 0 ? void 0 : data.attachments) === null || _b === void 0 ? void 0 : _b.length)) || isBlackList ||
            isPrivateChat && !isWhiteList;
    }, [data, isBlackList]);
    var disableImageIcon = useMemo(function () {
        return isPrivateChat && !isWhiteList || isBlackList;
    }, [data, isBlackList, isPrivateChat]);
    var banEdit = useMemo(function () {
        return (isPrivateChat && !isWhiteList || isBlackList);
    }, [isBlackList, isPrivateChat, isWhiteList]);
    useEffect(function () {
        var _a;
        if (answerId && mode === COMMENT_EDIT_MODE.answer) {
            (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [answerId, textareaRef.current, mode]);
    var notAlloweMsg = useMemo(function () {
        if (isBlackList) {
            return t('chat.errors.blacklist');
        }
        else if (isPrivateChat && !isWhiteList) {
            return t('chat.errors.whitelist');
        }
        return '';
    }, [language]);
    var textarea = useMemo(function () { return (React.createElement(React.Fragment, null, banEdit ? notAlloweMsg : (React.createElement(React.Fragment, null,
        React.createElement(Input.Textarea, { maxLength: 800, value: data.text, className: "mobile-textarea", onChange: handleTextChange, autoFocus: true, placeholder: t('editor.placeholders.something') }))))); }, [data, t, language, banEdit, notAlloweMsg]);
    var title = useMemo(function () {
        if (mode === COMMENT_EDIT_MODE.add) {
            return t("chat.post.add_comment");
        }
        else if (mode === COMMENT_EDIT_MODE.edit) {
            return t("chat.post.update_comment");
        }
        else {
            return t("chat.post.answer");
        }
    }, [mode, language]);
    var imageComponent = useMemo(function () {
        return (React.createElement("div", { style: { display: imageMode ? 'block' : 'none' } },
            React.createElement(ImageArrayComponent, { isEditing: mode === COMMENT_EDIT_MODE.edit, attachments: data.attachments, onChange: handleAttachmentsChange, update: time })));
    }, [mode, data, language, handleAttachmentsChange, time]);
    // if (!profile || closedStatus === CHAT_CLOSED_STATUS.pause) {
    //     return null;
    // }
    return (React.createElement(CommentEditContainer, { disablePadding: mode === COMMENT_EDIT_MODE.answer, "data-message-id": "".concat(mode === COMMENT_EDIT_MODE.answer ? 'answer' : 'edit', "-container") },
        React.createElement(FlexBox, { width: '100%', direction: "column", directionMobile: "column", gy: 16, gyMobile: 16 },
            !isBlackList && (React.createElement(CommentEditTitle, null, title)),
            React.createElement(FlexBox, { width: '100%' },
                React.createElement(CommentInputContainer, { ref: textareaRef, className: "input-container", direction: "column", directionMobile: "column" }, textarea),
                disableImageIcon ? null : (React.createElement(FlexBox, { offsetLeft: 24, align: "flex-end" },
                    React.createElement(ImageIcon, { onClick: handleToggleMode })))),
            imageComponent),
        React.createElement(FlexBox, null,
            React.createElement(RectangularButtonFilled, { disabled: disableSubmit, onClick: onSubmit }, t("chat.post.send")))));
};
//# sourceMappingURL=CommentEdit.js.map